$(function () {
    var from_$input = $('.date_from').pickadate(),
        from_picker = from_$input.pickadate('picker');

    var to_$input = $('.date_to').pickadate(),
        to_picker = to_$input.pickadate('picker');

    if (from_picker && to_picker) {

        if (from_picker.get('value')) {
            to_picker.set('min', from_picker.get('select'));
        }
        if (to_picker.get('value')) {
            from_picker.set('max', to_picker.get('select'));
        }

        from_picker.on('set', function (event) {
            if (event.select) {
                to_picker.set('min', from_picker.get('select'));
            } else if ('clear' in event) {
                to_picker.set('min', false);
            }
        });

        to_picker.on('set', function (event) {
            if (event.select) {
                from_picker.set('max', to_picker.get('select'));
            } else if ('clear' in event) {
                from_picker.set('max', false);
            }
        });

        // mobile alignment fix for checkout picker
        function fixCheckoutPickerPosition() {
    if (window.innerWidth > 767) return;

    setTimeout(function () {
        var $picker = $('.picker--opened').last();

        if (!$picker.length) return;

        $picker.css({
            left: 'auto',
            right: 'auto',
            width: '92vw',
            maxWidth: '360px',
            transform: 'translateX(-50%)'
        });

        $picker.find('.picker__holder, .picker__frame').css({
            left: '0',
            right: 'auto',
            width: '100%',
            maxWidth: '100%',
            transform: 'none'
        });
    }, 10);
}

        to_$input.on('focus click', function () {
            fixCheckoutPickerPosition();
        });

        $(document).on('click touchstart', '.date_to', function () {
            fixCheckoutPickerPosition();
        });
    } else {
        console.error('Pickadate not initialized. Check if pickadate.js is loaded and selectors match.');
    }
});